import { j as i } from "../../../../jsx-runtime.BREq8dyb.js";
import { Stack as o, Chip as s, Select as m, Option as p } from "@mui/joy";
import { memo as u } from "react";
const x = u(({
  chipText: t,
  audienceConfigs: n,
  onSelect: r,
  testId: c,
  value: d
}) => /* @__PURE__ */ i.jsxs(o, { alignItems: "center", direction: "row", gap: 1, mt: 1, children: [
  t ? /* @__PURE__ */ i.jsx(s, { "data-testid": "audience-chip", size: "lg", children: t }) : null,
  /* @__PURE__ */ i.jsx(m, { id: c || "audience-select", onChange: (l, e) => r(n.find((a) => a.id === e) || null), placeholder: "Select an audience", sx: {
    flex: 1
  }, value: d, children: n.map(({
    name: l,
    id: e
  }) => /* @__PURE__ */ i.jsx(p, { value: e, children: l }, e)) })
] }));
x.displayName = "AudienceSelector";
export {
  x as default
};
//# sourceMappingURL=AudienceSelector.js.map
